export default {
	"item.ATotalOf12MonthsAOneTimePurchaseOfTheAnnualReadingPlanWithNoFollowUpFees": "共計12個月，一次性購買全年閱讀計劃，沒有後續費用",
	"item.SubscribeToTheProductDetailPageYourself": "自主訂閱商品詳情頁",
	"item.SelfSubscribedProductDetailPageBUYButton": "自自主訂閱商品詳情頁_購買按鈕",
	"item.TheNameOfThePaymentMethodSelected": "選中的支付方式名稱",
	"item.YouExistForAnActivatedCourse": "您存在已啟動課程",
	"item.SorryTheVerificationFailed": "抱歉，驗證未通過！",
	"item.MostRecentIssueStartDate": "最近一期開始日期：",
	"item.month": "月",
	"item.day": "日",
	"item.ConsecutiveSeasons": "連續包季",
	"item.quarter": "/季",
	"item.50OffPerSeason": "每季優惠50",
	"item.YearRoundPurchases": "全年購買",
	"item.500OffForTheWholeYear": "全年優惠500",
	"item.BuyNow": "立即購買"
}